import {useCallback} from 'react';

import {useMonitorRowState} from 'entities/monitor';
import {portMonitorAPI} from 'features/port/api/portMonitorAPI';
import {PortMonitorModalType} from 'features/port/lib/portMonitorHelper';
import {showCheckNowToast} from 'features/port/lib/getCheckNowToast';

import useCanCreatePortMonitor from './useCanCreatePortMonitor';

export interface IUsePortMonitorActions {
    activeModal: PortMonitorModalType,
    canCreate: boolean,
    openModal: (_type: PortMonitorModalType) => void,
    closeModal: () => void,
    checkNow: () => Promise<void>,
}

export const usePortMonitorActions = (uuid: string): IUsePortMonitorActions => {
    const {activeModal, setActiveModal, closeModal} = useMonitorRowState<PortMonitorModalType>();
    const canCreate = useCanCreatePortMonitor();
    const [checkPortMonitorNow] = portMonitorAPI.useCheckPortMonitorNowMutation();

    const checkNow = useCallback(async() => {
        try {
            showCheckNowToast(await checkPortMonitorNow(uuid).unwrap());
        } catch (error) {
            showCheckNowToast(error);
        }
    }, [checkPortMonitorNow, uuid]);

    return {activeModal, canCreate, openModal: setActiveModal, closeModal, checkNow};
};

export default usePortMonitorActions;
